import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/fr";
import { myroutes } from "../routes/webroute";
import {
  useUnreadCount,
  useNotifications,
  useMarkAsRead,
  useMarkAllAsRead,
} from "../hooks/useNotifications";
import NotificationDetailModal from "./NotificationsDetail";

dayjs.extend(relativeTime);

const ICONES = {
  dossiers: "bi-folder2-open text-primary",
  audiences: "bi-calendar-event text-warning",
  paiements: "bi-cash-coin text-success",
  communications: "bi-chat-dots text-info",
};

export default function NotificationBell({
  couleurIcone,
  lienVoirTout = myroutes.notifications_index,
  espace = "admin",
}) {
  const { data: count = 0 } = useUnreadCount();
  const { data: page, isLoading, refetch } = useNotifications(1);
  const markAsRead = useMarkAsRead();
  const markAllAsRead = useMarkAllAsRead();
  const [selection, setSelection] = useState(null);

  // Quand le compteur change (polling), on rafraîchit aussi la liste
  useEffect(() => {
    refetch();
  }, [count, refetch]);

  // Le panneau n'affiche que les 5 plus récentes
  const notifications = (page?.data ?? []).slice(0, 5);

  const ouvrir = (notif) => {
    if (!notif.lue) markAsRead.mutate(notif.id);
    setSelection(notif);
  };

  return (
    <li className="nav-item dropdown pe-3">
      <button
        type="button"
        className="nav-link nav-icon notification-bell-trigger border-0"
        data-bs-toggle="dropdown"
        aria-label={`Notifications${count > 0 ? `, ${count} non lue(s)` : ""}`}
      >
        <i className="bi bi-bell" style={couleurIcone ? { color: couleurIcone } : undefined}></i>
        {count > 0 && (
          <span className="badge bg-danger badge-number notification-bell-count">
            {count > 99 ? "99+" : count}
          </span>
        )}
      </button>

      <ul
        className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications"
        style={{ width: "360px", maxHeight: "450px", overflowY: "auto", fontFamily: "montserrat" }}
      >
        <li className="dropdown-header d-flex justify-content-between align-items-center">
          <span>
            {count > 0 ? `${count} notification(s) non lue(s)` : "Aucune notification non lue"}
          </span>
          {count > 0 && (
            <button
              type="button"
              className="btn btn-link btn-sm p-0"
              onClick={() => markAllAsRead.mutate()}
              disabled={markAllAsRead.isPending}
            >
              Tout marquer lu
            </button>
          )}
        </li>
        <li><hr className="dropdown-divider" /></li>

        {isLoading && <li className="text-center text-muted py-3">Chargement…</li>}

        {!isLoading && notifications.length === 0 && (
          <li className="text-center text-muted py-3">Aucune notification</li>
        )}

        {notifications.map((notif) => (
          <React.Fragment key={notif.id}>
            <li
              className="notification-item"
              onClick={() => ouvrir(notif)}
              style={{
                cursor: "pointer",
                backgroundColor: notif.lue ? "transparent" : "#eef6f6",
              }}
            >
              <i className={`bi ${ICONES[notif.module] ?? "bi-info-circle text-secondary"}`}></i>
              <div>
                <h4 className={notif.lue ? "" : "fw-bold"}>{notif.data?.titre}</h4>
                <p>{notif.data?.message}</p>
                <p>{dayjs(notif.created_at).locale("fr").fromNow()}</p>
              </div>
            </li>
            <li><hr className="dropdown-divider" /></li>
          </React.Fragment>
        ))}

        <li className="dropdown-footer">
          <Link to={lienVoirTout}>Voir toutes les notifications</Link>
        </li>
      </ul>

      <NotificationDetailModal
        notification={selection}
        onHide={() => setSelection(null)}
        espace={espace}
      />
    </li>
  );
}